module.exports = __webpack_public_path__ + "81d20a79a8937783130ec8f5d1ee4a48.svg";